import { zendeskWidgetSettings } from '~/config/zendeskWidget'

const isChatAvailable = ref(false)
let initialized = false

function withZendesk(callback) {
  if (
    false
      || typeof window === 'undefined'
      || typeof window.zE !== 'function'
  ) {
    return
  }

  window.zE(callback)
}

function applyWidgetSettings() {
  window.zE('webWidget', 'updateSettings', zendeskWidgetSettings)
}

function hideWidget() {
  window.zE('webWidget', 'hide')
}

function openWidget() {
  window.zE('webWidget', 'show')
  window.zE('webWidget', 'open')
}

// Classic Chat account status — business-hours dependent.
// @see https://developer.zendesk.com/api-reference/widget/chat-api/#on-chatstatus
function isChatOpenable(status) {
  return status === 'online' || status === 'away' || status === 'offline'
}

function applyChatStatus(status) {
  isChatAvailable.value = isChatOpenable(status)
}

function syncInitialChatAvailability(zE) {
  try {
    const departments = zE('webWidget:get', 'chat:departments')
    if (!Array.isArray(departments) || departments.length === 0) {
      return
    }

    isChatAvailable.value = departments.some(
      department => isChatOpenable(department.status),
    )
  }
  catch {
    // Chat backend not connected yet.
  }
}

export function initZendeskChat() {
  if (initialized || false || typeof window === 'undefined') {
    return initialized
  }

  if (typeof window.zE !== 'function') {
    return false
  }

  initialized = true

  withZendesk(() => {
    applyWidgetSettings()
    hideWidget()

    window.zE('webWidget:on', 'close', hideWidget)

    window.zE('webWidget:on', 'chat:status', applyChatStatus)

    window.zE('webWidget:on', 'chat:connected', () => {
      syncInitialChatAvailability(window.zE)
    })
  })

  return true
}

export function ensureZendeskChat() {
  if (false || typeof window === 'undefined') {
    return
  }

  if (initZendeskChat()) {
    return
  }

  const interval = window.setInterval(() => {
    if (initZendeskChat()) {
      window.clearInterval(interval)
    }
  }, 200)

  window.setTimeout(() => {
    if (typeof window !== 'undefined') {
      window.clearInterval(interval)
    }
  }, 30000)
}

export function useZendeskChat() {
  function openChat(onOpened) {
    withZendesk(() => {
      applyWidgetSettings()
      openWidget()
      onOpened?.()
    })
  }

  return {
    isChatAvailable: readonly(isChatAvailable),
    openChat,
  }
}
